import React, { Component } from "react";
import { InputField } from "../../../../common/custom-form/input-filter-component";
import { SelectField } from "../../../../common/custom-form/select-filter.component";

export class ManageLocationInfo extends Component {
    constructor(props){
        super(props);
        this.state={
            inputValue: "",
            filterSelected: "", 
            showTable: false,
            showRate: false,
            detailsDropdown:[
                {
                    "title":"Plan Features",
                    "subTitle":"Feature Name",
                    "dataTable":[
                        {              
                            HeaderItem:[
                                {
                                    name:"Contract Name"
                                },
                                {
                                    name:"Vendor"
                                }, {
                                    name:"Status"
                                },{
                                    showTable:false
                                }
                            ],
                            dataItem:[{            
                                columnItem1:"3G Hutchison (GB) Contract",
                                columnItem2: "3G Hutchison (GB)",
                                columnItem3: "Expired"                       
                            }, {            
                                columnItem1:"3G Hutchison (GB) Contract",
                                columnItem2: "3G Hutchison (GB)",
                                columnItem3: "Expired"
                            },{            
                                columnItem1:"3G Hutchison (GB) Contract",
                                columnItem2: "3G Hutchison (GB)",
                                columnItem3: "Expired"
                            }        
                            ]
            
                        }
                    ]
                },{
                    "title":"Plan Rates",
                    "subTitle":"Rate Name",
                    "dataTable":[
                        {              
                            HeaderItem:[
                                {
                                    name:"Contract Name"
                                },
                                {
                                    name:"Vendor"
                                }, {
                                    name:"Status"
                                }, {
                                    showTable:false
                                }
                            ],
                            dataItem:[{            
                                columnItem1:"3G Hutchison (GB) Contract",
                                columnItem2: "3G Hutchison (GB)",
                                columnItem3: "Expired"                       
                            }, {            
                                columnItem1:"3G Hutchison (GB) Contract",
                                columnItem2: "3G Hutchison (GB)",
                                columnItem3: "Expired"
                            },{            
                                columnItem1:"3G Hutchison (GB) Contract",
                                columnItem2: "3G Hutchison (GB)",
                                columnItem3: "Expired"
                            }        
                            ]
            
                        }
                    ]
                }
            ],
            selectFilter:[
                {
                    "FilterId":5,
                    "FilterName":"Account Number",
                    "FilterType":"Textbox",
                    "Page":"CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                },
                {
                    "FilterId":4,
                    "FilterName":"Circuit ID",
                    "FilterType":"Textbox","Page":
                    "CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                },
                {
                    "FilterId":7,
                    "FilterName":"Circuit Status",
                    "FilterType":"Textbox",
                    "Page":"CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                }
               ],
               dataTable:[
                {              
                    HeaderItem:[
                        {
                            name:"Contract Name"
                        },
                        {
                            name:"Vendor"
                        }, {
                            name:"Status"
                        }
                    ],
                    dataItem:[{            
                        columnItem1:"3G Hutchison (GB) Contract",
                        columnItem2: "3G Hutchison (GB)",
                        columnItem3: "Expired"                       
                    }, {            
                        columnItem1:"3G Hutchison (GB) Contract",
                        columnItem2: "3G Hutchison (GB)",
                        columnItem3: "Expired"
                    },{            
                        columnItem1:"3G Hutchison (GB) Contract",
                        columnItem2: "3G Hutchison (GB)",
                        columnItem3: "Expired"
                    }        
                    ]
    
                }
            ],
        }
    }

  
    render() {
        return(
            <>
                <div className="manage-order-container">
                        <div className="manage-order-detail">
                            <SelectField label="COUNTRY"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/> 
                            <InputField label="LOCATION SITE" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="ADDRESS 1" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="ADDRESS 2" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="CITY" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="STATE" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="ZIP" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="LOCATION CODE" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="COUNTRY CODE" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="OWNED/LEASED" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <InputField label="PRIMARY USE" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                            <SelectField label="STATUS"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>                                
                        </div>
                </div>                   
            </>
        )
    }
}